import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import { ClerkProvider } from '@clerk/react';
import { App } from './App';
import { BusinessProvider } from './context/BusinessContext';
import { initTheme } from './lib/theme';
import { CLERK_PUBLISHABLE_KEY, assertClerkConfigured } from './lib/clerk';
import './index.css';

// Apply saved theme before React mounts to avoid a flash
initTheme();

// Fail fast at startup if the Clerk key is missing.
assertClerkConfigured();

/**
 * Thin wrapper that gives ClerkProvider access to React Router's `navigate`,
 * so Clerk can route within the SPA instead of doing full page reloads.
 */
function ClerkWithRouter() {
  const navigate = useNavigate();

  return (
    <ClerkProvider
      publishableKey={CLERK_PUBLISHABLE_KEY}
      routerPush={(to) => navigate(to)}
      routerReplace={(to) => navigate(to, { replace: true })}
      signInFallbackRedirectUrl="/dashboard"
      signUpFallbackRedirectUrl="/dashboard"
      afterSignOutUrl="/"
    >
      <BusinessProvider>
        <App />
      </BusinessProvider>
    </ClerkProvider>
  );
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter>
      <ClerkWithRouter />
    </BrowserRouter>
  </StrictMode>,
);
